import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { 
  Card, 
  CardContent, 
  Typography, 
  Avatar, 
  Box, 
  List, 
  ListItem, 
  ListItemIcon, 
  ListItemText,
  Divider,
  Button,
  Alert,
  Snackbar
} from '@mui/material';
import { Person, Email, Business, Lock } from '@mui/icons-material';
import { getUsuarioId } from '../../componentes/http/actions/UsuarioAction';
import CambiarContrasenaModal from '../../componentes/modal/Usuarios/CambiarContrasenaModal';

const PerfilUsuario = () => {
  const [usuario, setUsuario] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  
  const token = localStorage.getItem('token');
  const decoded = jwtDecode(token);
  const userId = decoded["oid"];
  const userName = decoded["given_name"];
  const userLastName = decoded["family_name"];
  const userEmail = decoded["upn"];
  const userRol = decoded["rol"];

  useEffect(() => {
    const fetchUsuario = async () => {
      try {
        const usuarioData = await getUsuarioId(token, userId);
        setUsuario(usuarioData);
      } catch (error) {
        console.error('Error al obtener usuario:', error);
        setSnackbar({
          open: true,
          message: 'Error al cargar los datos del usuario',
          severity: 'error'
        });
      }
    };

    if (userId) {
      fetchUsuario();
    }
  }, [token, userId]);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handlePasswordChangeSuccess = () => {
    setSnackbar({
      open: true,
      message: 'Contraseña cambiada exitosamente',
      severity: 'success'
    });
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  // Verificar si el usuario no es externo (puede cambiar contraseña)
  const puedeEditarContrasena = usuario && !usuario.proveedorExterno;

  return (
    <>
      <Card sx={{ maxWidth: 800, margin: 'auto', mt: 4 }}>
        <CardContent>
          <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
            <Avatar sx={{ width: 80, height: 80, mb: 2 }}>{userName[0]}</Avatar>
            <Typography variant="h5" component="div">
              Perfil de Usuario
            </Typography>
          </Box>
          <Divider />
          <List>
            <ListItem>
              <ListItemIcon>
                <Person />
              </ListItemIcon>
              <ListItemText primary="Nombre" secondary={userName} />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <Person />
              </ListItemIcon>
              <ListItemText primary="Apellido" secondary={userLastName} />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <Email />
              </ListItemIcon>
              <ListItemText primary="Email" secondary={userEmail} />
            </ListItem>
            { userRol === 'Administrador' && (
              <ListItem>
                <ListItemIcon>
                  <Business />
                </ListItemIcon>
                <ListItemText primary="Rol" secondary={userRol} />
              </ListItem>
            )}
            
            {usuario?.proveedorExterno && (
              <ListItem>
                <ListItemIcon>
                  <Business />
                </ListItemIcon>
                <ListItemText 
                  primary="Proveedor Externo" 
                  secondary={usuario.proveedorExterno} 
                />
              </ListItem>
            )}
          </List>
          
          {puedeEditarContrasena && (
            <>
              <Divider sx={{ my: 2 }} />
              <Box display="flex" justifyContent="center">
                <Button
                  variant="contained"
                  startIcon={<Lock />}
                  onClick={handleOpenModal}
                  sx={{ mt: 1 }}
                >
                  Cambiar Contraseña
                </Button>
              </Box>
            </>
          )}
        </CardContent>
      </Card>

      <CambiarContrasenaModal
        open={openModal}
        onClose={handleCloseModal}
        userId={userId}
        onSuccess={handlePasswordChangeSuccess}
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default PerfilUsuario;